import { memo } from 'react';

import { ViewTypeName } from '@air/api/types';

import { type DefaultBoardlessConfigViewsParams } from '~/constants/configViews';
import { useBoardlessConfigViewObserver } from '~/hooks/useBoardlessConfigView/useBoardlessConfigViewObserver';
import { useGetPublicConfigViewOptions } from '~/swr-hooks/gallery/viewFields/useGetPublicConfigViewsOptions';

type PublicBoardlessConfigViewObserverProps = {
  pageId: string;
  defaultSort?: DefaultBoardlessConfigViewsParams['defaultSort'];
};

export const PublicBoardlessConfigViewObserver = memo(
  ({ pageId, defaultSort }: PublicBoardlessConfigViewObserverProps) => {
    const { data: galleryConfigOptions } = useGetPublicConfigViewOptions({
      viewType: ViewTypeName.gallery,
    });
    const { data: tableConfigOptions } = useGetPublicConfigViewOptions({
      viewType: ViewTypeName.table,
    });

    useBoardlessConfigViewObserver({
      defaultSort,
      galleryConfigOptionsData: galleryConfigOptions?.data,
      pageId,
      tableConfigOptionsData: tableConfigOptions?.data,
    });

    return null;
  },
);

PublicBoardlessConfigViewObserver.displayName = 'PublicBoardlessConfigViewObserver';
